import { useState } from "react";
import cn from "classnames";
import { EyeIcon, EyeOffIcon } from "components/ui/Icons";

type PasswordInputProps = {
  name: string;
  value: string;
  placeholder: string;
  autoComplete: string;
  onChange: (value: string) => void;
};

export const PasswordInput = ({ name, value, placeholder, autoComplete, onChange }: PasswordInputProps) => {
  const [shown, setShown] = useState(false);

  return (
    <span className={cn("pcpw", { "is-shown": shown })}>
      <input
        type={shown ? "text" : "password"}
        name={name}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        type="button"
        className="pcpw__eye"
        aria-label={shown ? "Hide password" : "Show password"}
        onClick={() => setShown((current) => !current)}
      >
        {shown ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </span>
  );
};
